<div class="container">
  <div>{{intermediary.organisationId}}</div>
  <div>{{intermediary.subagentId}}</div>
  <div>{{intermediary.telephone}}</div>
  <div>{{intermediary.email}}</div>
</div>

